export const environment = {
  production: false,
  css_styles: [
    'https://collection-style.ariitea.com/css/v2.0/lite.css',
    'https://collection-style.ariitea.com/css/v2.0/texts/colors/default/lite.css',
    'https://collection-style.ariitea.com/css/v2.0/utilities/background/default/lite.css',
    'https://collection-style.ariitea.com/css/v2.0/animations/collection/skeleton/lite.css',
  ],
  api_url: "https://api.manava-immobilier.ariitea.website/beta"
};
